<template>
  <div class="services-modal default-modal">
    <button type="button" class="default-modal__close" @click="$emit('closeAll')">
      <IconComponent name="close" />
    </button>
    <ImgComponent :head_img="data.img" />
    <form @submit.prevent.stop class="default-modal__body services-modal__body">
      <span class="services-modal__title">{{ data.title }}</span>
      <span class="services-modal__description">{{ data.description }}</span>
      <h4 class="services-modal__subtitle">Оставьте заявку</h4>
      <InputComponent
        v-model="form.phone.value"
        :errors="form.phone.errors"
        placeholder="номер телефона"
        mask="+7 (###) ###-##-##"
      />
      <button @click="submit" class="btn btn--black btn--md">
        <IconComponent v-if="loading" name="loading" />
        <span v-else> Отправить </span>
      </button>
      <span class="default-modal__documents">
        Нажимая на кнопку, вы соглашаетесь с
        <router-link :to="{ name: 'about', params: { link: 'termsOfUse' } }">
          условиями использования
        </router-link>
        и
        <router-link :to="{ name: 'about', params: { link: 'publicOffer' } }">
          публичной офертой
        </router-link>
      </span>
    </form>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";
import InputComponent from "components/inputs/InputComponent.vue";
import ImgComponent from "components/ImgComponent.vue";
import NotificationModal from "components/modal/components/NotificationModal.vue";
import POST from "@/graphql/mutations/ServiceClaimCreate.graphql";

export default {
  name: "ServicesModal",
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      loading: false,
      form: {
        phone: {
          value: "+7",
          errors: [],
        },
      },
    };
  },
  methods: {
    resetErrors() {
      Object.keys(this.form).forEach((key) => {
        this.form[key].errors = [];
      });
    },
    submit() {
      this.loading = true;
      this.resetErrors();
      this.$apollo
        .mutate({
          mutation: POST,
          context: {
            headers: {
              Authorization: "Bearer " + this.$store.state.apollo_token,
            },
          },
          variables: {
            service: this.data.id,
            phone: this.form.phone.value,
          },
        })
        .then(() => {
          this.loading = false;
          this.$store.state._modals = [];
          this.$store.state._modals.push({
            component: NotificationModal,
            options: {
              title: "Спасибо!",
              description: "Ваша заявка на рассмотрении",
            },
          });
        })
        .catch(({ graphQLErrors }) => {
          this.parseGqlErrors(graphQLErrors);
          this.loading = false;
        });
    },
    parseGqlErrors(graphQLErrors) {
      graphQLErrors.forEach((err) => {
        if (err.extensions.category === "validation") {
          Object.keys(err.extensions.validation).forEach((key) => {
            if (this.form[key]) {
              this.form[key].errors.push(err.extensions.validation[key][0]);
            }
          });
        }
      });
    },
  },
  components: { ImgComponent, InputComponent, IconComponent },
};
</script>

<style lang="stylus">
.services-modal {
  max-width: 540px;
  padding: 0
  overflow hidden

  & .default-modal__close {
    position: absolute;
    right: 30px;
    top: 32px;
    background var(--white)
  }

  &__title {
    font-weight: 600;
    font-size: 1.5rem
    line-height: 28px;
    text-transform: uppercase;
    color var(--black)
  }

  &__subtitle {
    font-weight: 600;
    font-size: 1rem
    line-height: 28px;
    text-transform: uppercase;
    color var(--black)
  }

  &__body {
    padding: 30px
  }

  &__description {
    font-weight: 400;
    font-size: 1.25em;
    line-height: 32px;
    color: #1F2229;
  }
}
</style>
